module.exports = __webpack_public_path__ + "static/media/sachin-3.92c6c8d7.jpg";